const SectionItemSubtitle = ({ subtitle }) => {
  return (
    <span className="text-[10px] md:text-[12px] lg:text-[14px] font-section-description text-ellipsis overflow-hidden">
      {subtitle}
    </span>
  );
};

export default SectionItemSubtitle;
